import { TasksStatusId, TaskStatusLabel } from "@/constants/Tasks";

type AppUserTaskCache = Record<string, TaskItem[]>;

const updateSelectedUserTasks = ({
  oldCache,
  selectedUserId,
  taskId,
  taskStatusId,
}: {
  oldCache: AppUserTaskCache;
  selectedUserId: string;
  taskId: string;
  taskStatusId: number;
}): AppUserTaskCache => {
  if (!(selectedUserId in oldCache)) {
    return oldCache;
  }
  const currentUserTasks = oldCache[selectedUserId];

  if (taskStatusId === TasksStatusId.InProgress) {
    const updatedTasks = currentUserTasks.map((task) => {
      if (task.taskExternalId === taskId) {
        return {
          ...task,
          taskStatus: TaskStatusLabel.InProgress,
        };
      }
      return task;
    });
    return {
      ...oldCache,
      [selectedUserId]: updatedTasks,
    };
  }
  const excludeUpdatedTask = currentUserTasks.filter(
    (task) => task.taskExternalId !== taskId,
  );

  return {
    ...oldCache,
    [selectedUserId]: excludeUpdatedTask,
  };
};

export type { AppUserTaskCache };
export { updateSelectedUserTasks };
